import {HttpModelConverter} from '../../core/converter/httpModel.converter';
import {ValueAndLabelModel} from '../model/valueAndLabel.model';
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class ValueAndLabelConverter extends HttpModelConverter<ValueAndLabelModel> {

    protected enrichObject(result: ValueAndLabelModel, src: ValueAndLabelModel) {
    }

    protected createInstance(): ValueAndLabelModel {
        return new ValueAndLabelModel();
    }




}
